// src/data/projectsData.js
const projectsData = [
    {
      title: "House Price Predictor",
      description: "Predict Canadian house prices using ML.",
      techStack: ["Flask", "Streamlit", "Scikit-Learn", "Python"],
      github: "https://house-price-predictor-for-lh.streamlit.app/",
      demo: "https://house-price-predictor.streamlit.app",
      image: "/images/house_price.png", 
    },
    {
      title: "E-commerce Backend",
      description: "An enterprise-level e-commerce backend system.",
      techStack: ["Spring Boot", "PostgreSQL", "JWT"],
      github: "https://github.com/arya-2407/springboot-ecom",
      demo: "",
      image: "/images/ecommerce.png",
    },

    {
      title: "StudyBuddies",
      description: "Making studying fun (VikeLabs Hackathon #2 place).",
      techStack: ["React Native", "Node.js","Python"],
      github: "https://github.com/PABLO-HACKERS/studybuddies",
      demo: "",
      image: "/images/buddies2.webp",
    },

    {
      title: "Custom Linux Shell",
      description: "Implemented Linux shell from scratch.",
      techStack: ["C"],
      github: "https://github.com/arya-2407/custom-shell",
      demo: "",
      image: "/images/shell2.png",
    },

    {
      title: "Train Scheduling Simulator",
      description: "Implemented multithreading and a priority algorithm.",
      techStack: ["C","pthread"],
      github: "https://github.com/arya-2407/train-scheduling-simulator",
      demo: "",
      image: "/images/train.webp",
    },

    {
      title: "Neural Network from scratch",
      description: "Built a simple neural network with just NumPy and pandas.",
      techStack: ["Python", "NumPy", "pandas"],
      github: "https://github.com/arya-2407/NeuralNetworkFromScratch",
      demo: "",
      image: "/images/nn.webp",
    },
    
    // Add more projects here...
  ];
  
  export default projectsData;
  